import {BrowserRouter, Route, Routes} from "react-router-dom";
import FireTVKeyboard from "src/pages/FireTVKeyboard";
import {CookiesProvider} from "react-cookie";

export default function App() {
    // This is required to allow active pseudo state in iOS
    document.addEventListener("touchstart", function() {},false);

    return (
        <CookiesProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<FireTVKeyboard/>}/>
                </Routes>
            </BrowserRouter>
        </CookiesProvider>
    );
}